import { sdk } from "@/config/medusa";
import { useUser } from "@/context/user";
import { getRoutes, handleErrorToast } from "@/utils/helpers";
import { useNavigate } from "react-router-dom";

const useHeaderTop = () => {
  const routes = getRoutes();
  const navigate = useNavigate();
  const setGlobalLoading = useUser((state) => state.setGlobalLoading);
  const logout = useUser((state) => state.logout);

  const onProfile = () => {
    navigate(routes.vendorUser);
  };

  const onLogout = async () => {
    try {
      setGlobalLoading(true);

      sdk.auth.logout();
      logout();
      
      navigate(routes.signIn);
    } catch (e) {
      handleErrorToast(e);
    } finally {
      setGlobalLoading(false);
    }
  };

  const onLogo = () => {
    navigate(routes.dashboard);
  };

  return { onLogout, onProfile, onLogo };
};

export { useHeaderTop };
